import React from "react";

export default function PlusIcon({ fill, className, onClick }) {
    return (
        <svg onClick={onClick} className={className} width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1.53809 5.05566C2.71297 4.92512 7.68448 5.00127 10.0234 5.05566M5.78073 9.2983V0.813023" stroke={fill ? fill : "#4F6E90"} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
    );
}